import { useNavigate } from 'react-router-dom'
import posthog from 'posthog-js'
import usePayables from 'modules/easyPay/hooks/usePayables'
import { PulseCard } from 'components/states'
import { toman } from 'utilities/helper/format'

/**
 * «تعهدات قابل پرداخت شما» — the tab's hero.
 *
 * Shares `['get-all-payment']` with the home card and the pay screen, so this
 * costs no additional request.
 *
 * Two things changed from the Android transcription. It was a full-bleed slab
 * of #74B743 with the amount in #09314C — dark navy on mid-green, the worst
 * contrast pairing on the screen and the one carrying the number people came
 * to read; the amount is now white. And it announced «۰ تومان» in 26px to
 * anyone who owed nothing, next to a پرداخت آسان button that opened an empty
 * basket; that case now says so plainly, the way home does.
 */
export default function AccessPay() {
    const navigate = useNavigate()
    const { summary, isLoading } = usePayables()

    if (isLoading) return <PulseCard />

    if (!summary.hasAnything) {
        return (
            <div className="bg-white border border-divider rounded-card p-4 text-center">
                <p className="text-sm font-bold text-heading">
                    تعهدات قابل پرداخت شما
                </p>
                <p className="mt-1 text-sm text-text-secondary">
                    فعلاً پرداختنی ندارید
                </p>
            </div>
        )
    }

    return (
        <div className="bg-green-1 rounded-card shadow-fab p-4 flex items-center gap-3">
            <div className="flex-1 min-w-0 text-right">
                <p className="text-white/90 text-xs">تعهدات قابل پرداخت شما</p>
                <p className="text-white text-[26px] font-bold leading-tight mt-[2px]">
                    {toman(summary.grandTotal)}
                </p>
            </div>
            <button
                type="button"
                className="shrink-0 bg-white rounded-full px-4 py-1.5 text-sm font-bold text-brand-deep shadow-badge cursor-pointer active:scale-95 transition-transform"
                onClick={() => {
                    posthog.capture('payables_opened', {
                        source: 'funds_hero',
                    })
                    navigate('/easy-pay')
                }}
            >
                پرداخت آسان
            </button>
        </div>
    )
}
